import thunkReducer from '../../../helpers/thunkReducer'
import * as STATES from '../../../constants/states'
import * as actionTypes from '../constants/actionTypes'

export default {
  [STATES.PERMISSIONS]: thunkReducer(actionTypes.PERMISSIONS),
}
